/*
Base classes for manager classes. These should be treated as abstract classes
and never be instantiated directly.
*/

export class BaseManager {
  /* Required by child class. */
  dataProps = {};

  /* Optional overrides. */
  _ServiceClass = undefined;

  get() {
    return this._get("/");
  }

  _getComputedProperties(placeholder) {
    return placeholder;
  }

  /* Do not override the below methods and properties */
  _data = {};

  set data(newData) {
    if (typeof newData == "object") {
      let placeholder = {};
      Object.keys(this.dataProps).forEach(key => {
        placeholder[key] =
          typeof newData[key] == this.dataProps[key] ? newData[key] : null;
      });
      this._data = this._getComputedProperties(placeholder);
    }
  }

  get data() {
    return this._data;
  }

  _get(path) {
    return this._ServiceClass.get(path).then(data => (this.data = data));
  }

  _post(path, form) {
    return this._ServiceClass.post(path, form);
  }
}

export class BaseListManager {
  /* Required by child class. */
  _InstanceClass = undefined;
  _ServiceClass = undefined;

  /* Optional overrides. */
  get() {
    return this._get("/");
  }

  /* Do not override the below methods and properties */
  _data = [];
  _previous = null;
  _next = null;
  _count = 0;

  _handleGetResponse(response) {
    this.data = response.results;
    this._previous =
      typeof response.previous == "string" ? response.previous : null;
    this._next = typeof response.next == "string" ? response.next : null;
    this._count = response.count;
  }

  set data(newData) {
    if (typeof newData === "object") {
      let placeholder = [];
      newData.forEach(itemData => {
        let ItemManager = new this._InstanceClass();
        ItemManager.data = itemData;
        placeholder.push(ItemManager);
      });
      this._data = placeholder;
    }
  }

  get data() {
    return this._data;
  }

  get count() {
    return this._count;
  }

  get hasPrevious() {
    return this._previous !== null;
  }

  get hasNext() {
    return this._next !== null;
  }

  /* API calls */

  _get(path) {
    return this._ServiceClass
      .get(path)
      .then(data => (this.data = this._handleGetResponse(data)));
  }

  next() {
    if (this.hasNext) {
      return this._ServiceClass
        .paginate(this._next)
        .then(data => this._handleGetResponse(data));
    } else {
      return Promise.resolve(true);
    }
  }

  previous() {
    if (this.hasPrevious) {
      return this._ServiceClass
        .paginate(this._previous)
        .then(data => this._handleGetResponse(data));
    } else {
      return Promise.resolve(true);
    }
  }
}
